import styled from 'styled-components';
import Collapse from 'rc-collapse';
import { Props } from './types';

type T = Pick<Props, 'palette'>;

export const CollapseStyled = styled(Collapse)<T>`
  border-radius: 0;
  border: none;
  margin-bottom: 12px;
  background: transparent;

  & .rc-collapse-content {
    padding: 0;
    background: transparent;

    & .rc-collapse-content-box {
      margin: 8px 0;
    }
  }
`;
